import Vue from 'vue'
import moment from 'moment'

function yesNoFilter(value) {
    if (!value) return "No"
    return Boolean(value) === true ? "Yes" : "No";
}

function enabledDisabledFilter(value) {
    if (!value) return "Disabled"
    return Boolean(value) === true ? "Enabled" : "Disabled";
}

function dateTimeFilter(value) {
    if (!value) return ""
    return moment(value).format("DD MMM YYYY HH:mm");
}

Vue.filter('YesNo', yesNoFilter);
Vue.filter('EnabledDisabled', enabledDisabledFilter);
Vue.filter('DateTime', dateTimeFilter);

export default {
    yesNoFilter,
    dateTimeFilter,
    enabledDisabledFilter
}